module.exports = __webpack_public_path__ + "img/Spider-chart-icon.d3bb25a6.svg";